import { LocalStorageService } from './../../../../../core/services/local-storage.service';
import { CraEsnService } from './../../../../../core/services/cra-esn/cra-esn.service';
import { Component } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  serverError,
  successAddworkfloww,
} from './../../../../../core/models/messages';
import { EsnpermissionService } from './../../../../../core/services/esnpermission/esnpermission.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-workflow-clientconsultant',
  templateUrl: './workflow-clientconsultant.component.html',
  styleUrls: ['./workflow-clientconsultant.component.css'],
})
export class WorkflowClientconsultantComponent {
  formWorkFlow: FormGroup = this.createWorkFlowForm();
  company_id: any;
  currentStep: number = 1;
  listrole: any;

  name = [
    { id: '1', name: 'Consultant' },
    { id: '2', name: 'Responsable' },
    { id: '3', name: 'RH' },
  ];
  state = [
    { id: '1', name: 'Validé' },
    { id: '2', name: 'Rejeté' },
  ];
  listroleWithStatic!: Array<{ id: number, name: string }>;

  list: { id: number; name: string }[] = [];
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private serviceCraEsn: CraEsnService,
    private spinner: NgxSpinnerService,
    private roleservice: EsnpermissionService,
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.company_id = this.localStorageService.getData('clientConnected');
    this.getAllListClient();
    this.getListrole();
  }
  createWorkFlowForm(data?: any) {
    return this.formBuilder.group({
      company_id: [this.localStorageService.getData('clientConnected')],
      // company_id_specific: [data?.company_id_specific || null],
      consultant_ids: [data?.consultant_ids || []],
      state_workflow: ['2'],
      subWorkFlows: this.formBuilder.array(
        Array.isArray(data?.subWorkFlows) && data?.subWorkFlows.length
          ? data.subWorkFlows.map((item: any) =>
              this.createFormssubWorkFlows(item)
            )
          : [this.createFormssubWorkFlows()]
      ),
    });
  }
  createFormssubWorkFlows(data?: any) {
    return this.formBuilder.group({
      name: [data ? data.name : ''],
      // state: [data ? data.state : null, [Validators.required]],
      custom_role_id: [
        data ? data.custom_role_id : null,
        [Validators.required],
      ],
      step: [data ? data.step : '1'],
      responsable_project : [data ? (data.responsable_project  === 1 ? 1 : 0) : 0]

    });
  }
  /* create workflow general*/
  createWorkflow() {
    this.spinner.show();

    this.serviceCraEsn
      .createWorkFlowForm(this.formWorkFlow.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('res', this.formWorkFlow.value);
          this.spinner.hide();

          this.toastrService.success(successAddworkfloww);
          this.formWorkFlow.reset();
          this.router.navigate(['/cra/list-workflow']);
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            if (err.error.message['name']) {
              // Swal.fire(this.toastMessages.error);
              // this.toastr.error(this.toastMessages.error);
            } else {
              this.toastrService.error(serverError);
            }
          }
        },
      });
  }
  onRoleChange(index: number) {
    const formGroup = this.subWorkFlowsControls.at(index);
    const selectedRoleId = formGroup?.get('custom_role_id')?.value;
  
    if (selectedRoleId === 1) {
      formGroup?.get('custom_role_id')?.setValue(null);
      formGroup?.get('responsable_project')?.setValue(1);
    } else {
      formGroup?.get('responsable_project')?.setValue(0);
    }
  }
  addsubWorkFlows() {
    const subWork = this.formWorkFlow.get('subWorkFlows') as FormArray;
    const newSubWorkflow = this.createFormssubWorkFlows();
    const nextStepNumber = subWork.length + 1;
    newSubWorkflow.patchValue({
      step: nextStepNumber,
    });
    subWork.push(newSubWorkflow);
  }
  get subWorkFlowsControls(): AbstractControl<any, any>[] {
    return (this.formWorkFlow.get('subWorkFlows') as FormArray)?.controls || [];
  }
  removesubWorkFlows(index: number) {
    const subWorkFlows = this.formWorkFlow.get('subWorkFlows') as FormArray;
    if (subWorkFlows.length > 1) {
      subWorkFlows.removeAt(index);
    }
  }
  ResetForm() {
    this.formWorkFlow.reset();
    // this.modalRef!.hide();
  }
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  getAllListClient() {
    this.spinner.show();
    let company_id = this.localStorageService.getData('clientConnected');
    let esn_name = this.localStorageService.getData('clientConnectedName');

    this.serviceCraEsn
      .getAllconsultantexterne(esn_name)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          console.log('liste listclient', res);
          this.list = res.data;
          console.log('loggggglist', this.list);
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  getListrole() {
    this.roleservice.getlisteroles(this.company_id).subscribe({
      next: (response) => {
        console.log('response', response);
        if (response.data) {
          this.listrole = response.data;
          this.listroleWithStatic = [
            { id: 1, name: 'Responsable project' },
            ...this.listrole 
          ];
          console.log('list roles', this.listrole ,"listroleWithStatic",this.listroleWithStatic);
  
        }
       
      },
      error: (error) => {
        console.error('Error fetching roles: ', error);
      },
    });
  }
}